import {Button, Top} from "parts";
import {Plan} from "parts/paywall";
import {setTrack} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {BookEnum} from "_business";
import i18n from "i18next";
import {BookComments} from "parts/book";
import React, {useEffect} from "react";

export function BookBundle({price, onClick, onSkip, message}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'book.bundle'})

  useEffect(() => {
    setTrack(BookEnum.bundle)
  }, [])

  return (
    <div className={'wrap'}>
      <Top type={'center'}>
        {message && <div id="payment-message">{message}</div>}

        <h1 className={'text-center pre-line w-100'}>
          <Trans i18nKey="h1" t={t}>
            Start strong with the
            <span className={'marked'}>Voice Essentials</span> Pack
          </Trans>
        </h1>

        <BookInfo t={t} price={price} onSkip={onSkip}
                  onClick={() => onClick('top')}
        />

        <BookOne t1={t} number={1} prefix={'ultimate'}
                 background={'linear-gradient(79.63deg, #6589EC 7.74%, #391A6B 92.26%)'}
        />
        <BookOne t1={t} number={2} prefix={'accent'}
                 background={'linear-gradient(79.63deg, #9BE760 7.74%, #015552 92.26%)'}
        />

        <BookComments/>

        <BookInfo t={t} bottom={true} price={price} onSkip={onSkip}
                  onClick={() => onClick('bottom')}
        />
      </Top>
    </div>
  )
}

function BookOne({t1, number, prefix, background}) {
  const {t} = useTranslation('common', {keyPrefix: 'book'})

  return (
    <>
      <h2 className={'h1'}>
        #{number} {t(`${prefix}.h2`)}
      </h2>

      <div className={'block items h-100 rounded-2'}
           style={{
             alignItems: 'center', padding: '19px 14px', gap: 15,
             background
           }}
      >
        <div className={'row center'}>
          <div>
            <img alt="" width={214} height={218} className={'mw-100 w-100'}
                 style={{margin: '-20px -40px -40px 0'}}
                 src={`/static/img/book/${prefix}.png`} loading={'lazy'}
            />
          </div>
          <div className={'text-start items gap-3'} style={{minWidth: 146}}>
            <h3>{t1(`${prefix}.header`)}</h3>
            <p className={'small'}>{t1(`${prefix}.desc`)}</p>

            <div className={'row sm'}>
              <Trans i18nKey={`${prefix}.tags`} t={t}>
                <span className={'tag tag-btn-sm'}>e-book</span>
                <span className={'tag tag-btn-sm'}>pdf</span>
              </Trans>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function BookInfo({bottom = false, t, price, onClick, onSkip}) {
  const {t: t0} = useTranslation('common')

  const handleItemContent = item => {
    const itemBook = item[BookEnum.bundle]

    return (
      <>
        <div className={'w-100 text-start'}>
          <strong>{itemBook.name[i18n.resolvedLanguage]}</strong>
          <p><s className={'note lg'}>
            {t('plan.regularPrice')} {item.currency} {itemBook.old_price}
          </s></p>
        </div>
        <div className={'nowrap'}>
          <sup>{item.currencySymbol}</sup>
          <big>{Math.trunc(itemBook.price)}</big>
          <div>
            <em>{Math.round(itemBook.price % 1 * 100)}</em>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className={'block text-center stack'}
         style={{
           paddingBottom: 20,
           // background: 'radial-gradient(50% 50% at 50% 50%, rgba(255, 57, 255, 0.32) 0%, rgba(255, 57, 255, 0) 100%), linear-gradient(0deg, #121620, #121620)'
         }}
    >
      <img src={'/static/img/book/combo.png'} alt="book" width={310} height={160} className={'mw-100 w-100'}/>

      <div className={'items'}>
        <p className={'notice mb-1'}>{t('notice')}</p>

        <Plan path={'discount'} book={BookEnum.bundle} discount={true} strict={true} price={price}
              itemContent={handleItemContent}
        >
          <Button onClick={onClick}>{t('plan.btn' + (bottom ? '2' : ''))}</Button>
          <Button variant={''} onClick={onSkip}>{t0('next')}</Button>
        </Plan>
      </div>
    </div>
  )
}